
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 18 18\" id=\"icon-basket\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <rect x=\"7.043\" y=\"5.791\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" width=\"3.963\" height=\"1.873\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z\r\n\t\t M12.239,13.981H5.76L2.924,7.664h2.347v-2.03c0-0.891,0.723-1.615,1.611-1.615h4.279c0.891,0,1.617,0.724,1.617,1.615v2.03h2.297\r\n\t\tL12.239,13.981z\"/> </g> </symbol>";
module.exports = sprite.add(image, "icon-basket");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/basket.svg
 ** module id = 147
 ** module chunks = 24
 **/